import React from 'react';
import { Eye } from 'lucide-react';
import { usePermissions } from '../contexts/PermissionContext';

const ViewerBanner = () => {
  const { isViewer } = usePermissions();

  if (!isViewer) {
    return null;
  }

  return (
    <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border-l-4 border-blue-500 p-4 mb-6 rounded-r-lg shadow-sm">
      <div className="flex items-start gap-3">
        <div className="flex-shrink-0">
          <Eye className="h-6 w-6 text-blue-600" />
        </div>
        <div className="flex-1">
          <h3 className="text-sm font-semibold text-blue-900 mb-1">
            Viewing in Read-Only Mode
          </h3>
          <p className="text-sm text-blue-700">
            You have view-only access to this business. You can explore the data but cannot make any changes or submit forms.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ViewerBanner;
